module.exports = __webpack_public_path__ + "media/hyper/images/layouts/layout-6-e3da7500a043a0996fdb15ab9fb0de03.png";